export { default } from './SecondaryMenuList';
